import type { ScopedThreadRef } from "@cmmd-forge/contracts";
import { BreadcrumbThreadActions } from "../breadcrumb/BreadcrumbThreadActions";
import { AppTopBarActions } from "../appTopBarActionSlot";
import { ChatHeader } from "./ChatHeader";

export function RemoteThreadHeader({
  authorized,
  threadRef,
  runtimeId,
  ...header
}: {
  readonly authorized: boolean;
  readonly threadRef: ScopedThreadRef;
  readonly runtimeId: string;
}) {
  return (
    <>
      {authorized ? (
        <BreadcrumbThreadActions
          threadRef={threadRef}
          runtimeId={runtimeId}
          runtimeAvailable={false}
        />
      ) : null}
      <AppTopBarActions>
        <ChatHeader
          {...header}
          runtimeControlsDisabledReason="Available after sending a message or reconnecting to an active turn."
        />
      </AppTopBarActions>
    </>
  );
}
